//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'CatalogBrands',

	props: {
		tags: {
			type: Array,
			required: true,
			validator: function validator(val) {
				return val.length;
			}
		}
	},

	computed: {
		tag: function tag() {
			return this.$route.query.tag;
		},
		brand: function brand() {
			return this.$route.query.brand;
		},
		type: function type() {
			return this.$route.query.type;
		},
		filter: function filter() {
			return this.$route.query.filter;
		}
	},

	methods: {
		setPath: function setPath(brand) {
			var str = '?';

			if (this.tag) str = str + '&tag=' + this.tag;
			if (this.filter) str = str + '&filter=' + this.filter;
			if (brand) str = str + '&brand=' + brand;
			if (this.type) str = str + '&type=' + this.type;

			if (str === '?') return '';
			return str.replace('&', '');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogBrands.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogBrands.vue
// module chunks = 0